export const isExternalLink = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    const internalDomains = ['nerdwallet.com', 'nerdwallet.biz'];
    return !internalDomains.some(domain => parsedUrl.origin.endsWith(domain));
  } catch {
    return false;
  }
};
